<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ng-container [formArrayName]="parentFormArrayName">
  @for (hiddenInput of fileLinkControls.controls; track hiddenInput; let i = $index) {
    <input id="file-link-{{ i }}" type="hidden" [formControlName]="i" />
  }
</ng-container>

<ods-file-upload-button
  [id]="uploadFileId"
  [accept]="accept"
  [attr.data-test-id]="(label | convertForDataTest) + '-file-upload-button'"
  [isLoading]="uploadInProgress.loading"
  class="relative w-full max-w-72"
  dataTestId="file-upload-editor"
  icon="attach-file"
  [text]="label"
/>
